
import toast from "react-hot-toast";
import instance from "./api";
import { execute } from "./response";

const endpoints = {
  venues: `${process.env.REACT_APP_API_URL}/api/venues`,
};

const fetchAllVenues = async (params) => {
  const queryParams = params
    ? params.map((x) => `${x.key}=${x.value}`).join("&")
    : "";
  const res = await instance.get(
    `${endpoints.venues}${queryParams ? `?${queryParams}` : ""}`
  );
  return res.data;
};

const mergeVenues = async (sport, data) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/venues/${sport}/merge`;
  return execute(() => instance.post(endpoint, data));
};

const matchVenuesByAi = async (sport) => {
  try {
    const endpoint = `${process.env.REACT_APP_API_URL}/api/venues/${sport}/ai/match`;
    const result = await execute(() => instance.post(endpoint));
    return result;
  } catch (e) {
    console.log(e);
    toast.error('Servers are busy. Try again later!');
  }
};

const approveVenue = async (id) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/venues/${id}/approve`;
  return execute(() => instance.post(endpoint));
};

const unapproveVenue = async (id) => {
  const endpoint = `${process.env.REACT_APP_API_URL}/api/venues/${id}/unapprove`;
  return execute(() => instance.post(endpoint));
};

export { fetchAllVenues, mergeVenues, matchVenuesByAi, approveVenue, unapproveVenue };
